export default __webpack_public_path__ + "static/media/client-03.95fe4b0c.webp";